import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Select,
  Checkbox,
  DatePicker,
  Message,
  Card,
  Table,
  Switch,
  NumberPicker,
  Calendar,
  List
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import Swal from 'sweetalert2'
import moment from 'moment';
import 'antd/dist/antd.css';
import { Modal } from 'antd'; //dialog UI

import axios from "axios";
import ezconImg from "../../../../../public/ezcon.png";
const Option = Select.Option;
const { Item } = Form;
const currentDate = moment();
const localeData = currentDate.clone().localeData();
const monthLocale = localeData.monthsShort();
const PatrolFrontDeskList = (props) => {
  //residentAccountNumbers 戶號Table
  const residentAccountNumbers = client.service('residentAccountNumbers');
  //clean 公告Table
  const clean = client.service('clean');
  const [cleanArr, setCleanArr] = useState([]);
  const [cleanCurrentArr, setCleanCurrentArr] = useState([]);
  const [addCleanDialog, setAddCleanDialog] = useState(false);
  const [editCleanDialog, setEditCleanDialog] = useState(false);
  const [editCleanIndex, setEditCleanIndex] = useState('');
  const [titleText, setTitleText] = useState('');
  const [contentText, setContentText] = useState('');
  const [category, setCategory] = useState('');
  const [cleanTime, setCleanTime] = useState('');
  const [count, setCount] = useState(0);
  const [range, setRange] = useState('');
  const [previewDialog, setPreviewDialog] = useState(false);
  const [status, setStatus] = useState(false);
  //查詢
  function funFind(para) {
    return new Promise((resolve, reject) => {
      try {
        clean.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }


  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  //刷新頁面
  function serverDataUpdate() {
    funFind({}).then((result) => {
      setCleanArr(result.sort(ordersort));
    });
  }

  useEffect(() => {
    serverDataUpdate();
  }, []);



  function dateCellRender(date) {
    const dateNum = date.date();
    let str = '';
    // let str2 = ''
    for (let i = 0; i < cleanArr.length; i++) {
      let cleanTime = cleanArr[i]['cleanTime'];
      let formatTime = moment(cleanTime).format('YYYYMMDD');
      if (
        formatTime.substr(4, 2) == date.month() + 1 &&
        formatTime.substr(6, 2) == dateNum
      ) {
        str += `工作項目:${cleanArr[i]['name']}
        注意事項:${cleanArr[i]['contentText']}
        `;
      }
    }
    if (str) {

      const formatStr = str.split('\n').map((value, index) => {
        return (
          <div key={index}>{value}</div>
        )
      });
      return (
        <>
          <div className={styles.calendarMonthBox}>
            <div className={styles.calendarMonthText}>{dateNum}</div>
            <div>{formatStr}</div>
          </div>
        </>
      );
    }
    return dateNum;
  }

  function monthCellRender(date) {
    let str = '';
    for (let i = 0; i < cleanArr.length; i++) {
      let cleanTime = cleanArr[i]['cleanTime'];
      let formatTime = moment(cleanTime).format('YYYYMMDD');
      if (formatTime.substr(4, 2) == date.month() + 1) {
        str += `標題:${cleanArr[i]['name']}
        注意事項:${cleanArr[i]['contentText']}
        `;
      }
    }
    if (str) {
      const formatStr = str.split('\n').map((value, index) => {
        return (
          <div key={index}>{value}</div>
        )
      });
      return (
        <>
          <div>{monthLocale[date.month()]}</div>
          <div className={styles.calendarYearBox}>
            <div>{formatStr}</div>
          </div>
        </>
      );
    }
    return monthLocale[date.month()];
  }



  return (
    <>

      <Modal
        cancelText
        closable={false}
        mask={false}
        className={styles.dialog}
        visible={previewDialog}
        onOk={() => {
          setPreviewDialog(false);
        }}

        onCancel={() => {

          setPreviewDialog(false);
        }}
        okText="關閉"
      >
        <Form>
          <h1>清潔項目</h1>
          {cleanCurrentArr.map((list, index) => {
            return (
              <div key={index} className={styles.listContainer}>
                <Item label="清潔日期">
                  <p>{new Date(list.cleanTime).toLocaleDateString()}</p>
                </Item>
                <Item label="清潔項目">
                  <p>{list.name}</p>
                </Item>
                <Item label="注意事項">
                  <p>{list.contentText}</p>
                </Item>
                <Item label="工作週期">
                  <p>{list.cycle}</p>
                </Item>
              </div>
            )
          })}


        </Form>
      </Modal>
      {/* 日曆ＵＩ */}

      <Calendar
        // mode
        onSelect={(value) => {
          // console.log(new Date(value).getTime())

          clean.find({
            query: {
              cleanTime: new Date(value).getTime(),
            }
          }).then((res) => {

            console.log('==clean find success:', res.data);
            setPreviewDialog(true);
            setCleanCurrentArr(res.data)
            Message.success('找尋資料成功');
          })
            .catch((error) => {
              console.log('==clean find fail:', error);
              Message.success('找尋資料失敗');
            });

        }}

     

        dateCellRender={dateCellRender}
        monthCellRender={monthCellRender}
        yearRange={[2021, new Date().getFullYear() + 1]}
        value={moment().add(0, 'days')}

      />


    </>

  );
};

export default PatrolFrontDeskList;
